module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "PT1.1.3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Formal, Substantive, and Disaggregated Neutrality toward Religion")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "para9"
  }, [_c('em', [_vm._v("39 DePaul Law Review 993 (1990)")])]), _vm._v(" "), _c('p', {
    staticClass: "para4"
  }, [_c('em', [_vm._v("This was the Sixth Annual Lecture at the Center for Church/State Studies at DePaul University in Chicago. It is the first elaboration of “substantive neutrality,” a concept that has been foundational to much of my subsequent work. The core of the conceptual problem addressed in the lecture is this. Religious liberty sometimes requires that religiously motivated conduct be exempted from government regulation, so that believers can actually practice their faith. But regulatory exemptions on religious grounds look like special treatment for religion, and that seems inconsistent with another widely shared intuition, important in other religious liberty controversies: that government should be neutral toward religion. Is there a coherent understanding of neutrality that is consistent with full religious liberty?")])])]), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("A wide range of courts and commentators commonly say that government must be neutral toward religion."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1",
      "id": "ft4.1"
    }
  }, [_vm._v("1")]), _vm._v(" There are dissenters in both directions—those who think that government can support religion, and those who pursue separation to the point of hostility. In this Article, I will largely ignore those dissenters. I will assume that neutrality is an important part of the meaning of the Religion Clauses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This Article is about the meaning of neutrality. My goal is to clarify the concept, or at least to clarify our disagreements over its meaning. In the course of doing that, I will address a third group of dissenters—those who think that neutrality is meaningless and should be dropped from our discourse."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.2",
      "id": "ft4.2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Those who think neutrality is meaningless have a point. We can agree on the principle of neutrality without having agreed on anything at all. From benevolent neutrality"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.3",
      "id": "ft4.3"
    }
  }, [_vm._v("3")])]), _vm._v(" to separate but equal,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.4",
      "id": "ft4.4"
    }
  }, [_vm._v("4")])]), _vm._v(" people with a vast range of views on church and state have all claimed to be neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Consider "), _c('em', [_vm._v("Texas Monthly, Inc. v. Bullock.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.5",
      "id": "ft4.5"
    }
  }, [_vm._v("5")])]), _vm._v(" The Supreme Court said that Texas can not exempt the sale of religious publications from a sales tax that applies to all other publications. Justice Brennan and Justice Scalia fundamentally disagreed on almost every issue in the case, but they both claimed to be neutral."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.6",
      "id": "ft4.6"
    }
  }, [_vm._v("6")])]), _vm._v(" Both of them used the word “neutrality,” but neither of them defined it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most of us think of ourselves as fairminded, and so we tend to assume that our instinctive preferences are fair, and therefore neutral. Some scholars "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("have tried to define neutrality more carefully, but they have produced quite inconsistent definitions.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Both of these points—the power of our instincts and the inconsistency of formal definitions—were brought home to me when I presented a paper"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.7",
      "id": "ft5.7"
    }
  }, [_vm._v("7")]), _vm._v(" on the Equal Access Act."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.8",
      "id": "ft5.8"
    }
  }, [_vm._v("8")])]), _vm._v(" The Act tries to guarantee the right of student religious groups to meet in empty classrooms on the same terms as other extracurricular student groups. The Supreme Court has finally upheld the statute,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.9",
      "id": "ft5.9"
    }
  }, [_vm._v("9")])]), _vm._v(" ending six years of debate over its constitutionality. This seemed to me an easy case to resolve with the neutrality principle. I argued that government could not discriminate against religious speech by private speakers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A distinguished panel of commentators attacked me from all directions. Ruti Teitel insisted that the only neutral course was to exclude the religious speakers. She thought that my error was to treat as alike things that were different."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.10",
      "id": "ft5.10"
    }
  }, [_vm._v("10")])]), _vm._v(" Geoffrey Stone argued that neutrality permitted my solution, but certainly did not require it. He thought it was neutral to exclude the religion club if the school board also promised to exclude the atheist club, if there ever were one."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.11",
      "id": "ft5.11"
    }
  }, [_vm._v("11")])]), _vm._v(" Michael McConnell agreed with my solution, but he said my definition of neutrality was “heterodox.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.12",
      "id": "ft5.12"
    }
  }, [_vm._v("12")])]), _vm._v(" He insisted that neutrality is not a reliable principle, because properly defined, it is often at odds with religious liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It was McConnell’s attack that troubled me the most. I believe that neutrality is consistent with religious liberty—indeed, essential to its preservation. Our miscommunication did not seem to flow from any underlying policy disagreement. As a result of that exchange, I feared that other meanings of neutrality had so captured our vocabulary that I could not use the term to communicate, even to sympathetic audiences and even when I defined it. McConnell’s comment on my definition of neutrality made it inevitable that I would explore the definition in greater depth. I take considerable comfort from McConnell’s move toward a somewhat similar definition in the intervening four years."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.13",
      "id": "ft5.13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('strong', [_vm._v("I. Is Neutrality Worth Defining?")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Maybe these conflicting uses of “neutrality” prove that we should abandon the concept. A few years ago, Peter Westen stirred up a great fuss by claiming that equality is an empty concept."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.6.14",
      "id": "ft6.14"
    }
  }, [_vm._v("14")]), _vm._v(" Neutrality and equality are near cousins; they have most of the same attractions and most of the same inadequacies. If Westen were right, then neutrality would also be empty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am quite sure that Westen was wrong, but he highlighted something important that we too often ignore. Equality and neutrality are not empty concepts, but neither are they self-defining. They are insufficient concepts—insufficient to decide cases without supplemental principles. Let me briefly explain this point, with apologies to those who are familiar with the debate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A claim to equal or neutral treatment is very different from an outright claim of entitlement. If I go to court claiming a constitutional right to a monthly check from the government, the court will laugh at me. It is up to Congress, and not the courts, to create government benefit programs. But if I go to court claiming a constitutional right to a check on the same terms as someone similarly situated, I may have a serious claim. If Congress has given social security benefits to women in my situation but not to men, I will probably win."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.6.15",
      "id": "ft6.15"
    }
  }, [_vm._v("15")])]), _vm._v(" My claim to an equal entitlement to benefits is very different from my claim to an outright entitlement to benefits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nor is it the case that once we have fully specified the entitlement, equality drops out. Westen would say that once we decide that sex is not one of the "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("eligibility criteria, we no longer need equality to decide my case. That is descriptively true, but it is not true until after we have decided. It begs the question of how we decide that sex is not one of the eligibility criteria. The elimination of sex as a criterion will depend in part on our understanding of sexual equality, and not merely on the policy of the social security program.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This separation in theory is greatly reinforced in practice by the constitutional separation of powers. Congress first specifies the eligibility criteria, and has sole responsibility for social security policy. But the Court reviews those criteria to see if they violate its understanding of constitutional rights to equality. This separation of responsibility for policy definition is critical to the debate over Westen, and it has received too little attention. It means that equality claims can never be collapsed into the initial specification of the entitlement. So equality is not an empty concept.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But equality is an insufficient concept. No one claims that all five billion humans must be given precisely equal treatment in all matters. Some inequalities are considered fair and just, like punishing the guilty but not the innocent. Some are considered unfair but lawful, like homelessness in the midst of wealth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Only a few inequalities violate legal rights to equality. Claims about equality, or neutrality, always require further specification: equality with respect to what classification, for what purpose, in what sense, and to what extent? Let me briefly consider these four variables.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First, there is the classification at issue. Those who are similarly situated should be treated equally, but what does it mean to be similarly situated? If Congress grants benefits to 40-year-old women but not to 40-year-old men, my claim will specify equality with respect to sex, and I will probably win.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("But if I specify equality with respect to age—if I claim that 40-year-old men are similar to 65-year-old men—I will surely lose."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.7.16",
      "id": "ft7.16"
    }
  }, [_vm._v("16")]), _vm._v(" Our law embodies a fairly strong and general commitment to sexual equality, but only a weak and narrow commitment to age equality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, there is the purpose of the classification. What it means to be similarly situated depends on why we are asking. If I claim that my employer fired me because of my age, then I have a claim under the age discrimination laws."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.7.17",
      "id": "ft7.17"
    }
  }, [_vm._v("17")])]), _vm._v(" Forty-year-old men are similar to 65-year-old men for purposes of hiring and firing, but not for purposes of social security. Third, there are different "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("senses of equality. Two sharply different meanings are inherent in the concepts of equality and neutrality. These different meanings are familiar from the great national debate over affirmative action."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.8.18",
      "id": "ft8.18"
    }
  }, [_vm._v("18")]), _vm._v(" Americans believe in equal opportunity and equal treatment, but in some contexts, we also believe in equal impact and equal outcomes. This is not an all-or-nothing universal choice; our choices vary with context. Few people would argue that equal impact is never the relevant measure, but we often disagree over when equal impact is the relevant measure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Fourth, there is the extent of the claim. Is it sufficient for government to treat people equally when it imposes penalties and distributes benefits—to treat people equally in all tangible ways? Or do we also require government to be neutral in intangible ways as well—to be neutral in its speech and symbolic conduct? This distinction is critical to debates about religious neutrality. I will call it the difference between equality and neutrality. When I say government should be neutral towards religion, I mean to include the claim that it should not express an opinion about religion. But this is a controversial claim. Nothing in the concepts themselves will tell us whether the Religion Clauses commit government to neutrality in this sense, or only to equal treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The first three variables are also controversial and insufficiently specified. Equality with respect to religion does not even sufficiently specify the classification. Religion may refer to status, to belief, to speech, or to conduct. The principal line of disagreement is different for each of these.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most of our serious disagreements are about religious conduct, and not about religious status or belief. It is therefore religious conduct that is the principal subject of our inquiry into religious neutrality. Americans have very different intuitions about what it means to say that religious conduct is similarly situated to secular conduct, or what it means to treat religious conduct equally.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In religion as elsewhere, the answers sometimes depend on the second variable—the purpose of the classification. Whether we think religious conduct is similarly situated may depend on whether we are talking about direct regulation of conduct, resolution of private disputes, expenditures of government funds, taxation and tax exemption, and so on through the whole range of ways in which religion and government interact.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The debate over religious conduct also triggers sharp disagreement over the choice between equal treatment and equal impact. This may be the most fundamental source of disagreement about the meaning of neutrality toward religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Because neutrality requires so much further specification, it cannot be the only principle in the Religion Clauses. Nor can it be the most fundamental. We must specify the content of neutrality by looking to other principles in the Religion Clauses. When we have done that, neutrality should be defined in a way that makes it largely congruent with those other principles. We will often be able to explain the objection to a law by saying either that it restricts the autonomy of religious belief or practice, or that it threatens religious voluntarism, or that it deviates from religious neutrality, and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This variety of explanations is important, and the neutrality explanation should not be omitted. In a nation of immense religious diversity, it is of great symbolic value that government views all manner of religious belief neutrally. That the government aspires to religious neutrality, and that the courts stand ready to hold government to its aspiration, is an important reassurance to religious minorities. We should not abandon or de-emphasize that reassurance. We should not omit neutrality from our set of explanations, even if we also offer other explanations, and even if some readers believe that those other explanations are more fundamental. Neutrality has great explanatory importance.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Neutrality also continues to have operational importance. If neutrality properly understood is largely congruent with other principles of the Religion ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Clauses, then any of these principles can be the warning flag that calls attention to a threat to religious liberty. Sometimes the deviation from neutrality will be the most obvious explanation of the danger, and even the most fundamental.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("For example, I think neutrality is the most straightforward explanation in the equal access controversy. There is no general right to demand that the government make its property available for religious observance: there is not even such a right in narrow and especially appealing circumstances. The lack of such a right is implicit in "), _c('em', [_vm._v("Lyng v. Northwest Indian Cemetery Protective Association")]), _vm._v(","), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.10.19",
      "id": "ft10.19"
    }
  }, [_vm._v("19")]), _vm._v(" where the Court refused to stop the government from building a useless road on land owned by the government but sacred to Native Americans. There is no entitlement to special access to government property for religious exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, if the government makes its property available for meetings of nonreligious private groups, then it must make that property equally available to religious groups."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.10.20",
      "id": "ft10.20"
    }
  }, [_vm._v("20")])]), _vm._v(" This is a classic equality right. The equality or neutrality explanation is the one that best and most directly fits the case. Neutrality is the easiest way to recognize the problem, to decide the case, and to explain the result.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More generally, I doubt that there is any single foundational principle from which all the others can be derived. The Religion Clauses embody several principles, which are largely congruent, but occasionally in tension. The search for solutions is rarely a matter of deciding which principle is more fundamental. The search for solutions is more like an iteration in mathematics. In an iteration, you solve a problem by a series of approximations, each building on the one before, until you have as close an approximation as you need or as close as you can get with reasonable effort. We iterate Religion Clause problems by considering them in light of each of the relevant principles, including neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For all these reasons, I think that neutrality is worth defining. To that end, I will sketch the principal conceptions of neutrality toward religion in the cases and the literature, illustrating the differences with examples.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('strong', [_vm._v("II. Formal Neutrality")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("By far the best-known definition of religious neutrality is Philip Kurland’s. In 1961, he tendered the following principle:")])]), _c('p', {
    staticClass: "SmQuote1Sb"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("The [free exercise and establishment] clauses should be read as stating a single precept: that government cannot utilize religion as a standard for action or inaction because these clauses, read together as they should be, prohibit classification in terms of religion either to confer a benefit or to impose a burden."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.11.21",
      "id": "ft11.21"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("This standard of no religious classifications is closely akin to the equal treatment and equal opportunity side of the affirmative action debate. But the shift of context has enough implications so that a different label is required. I will call this standard “formal neutrality.” I will not call it Kurland’s Rule, because I am not sure he intended it in the way it has come to be understood. But I suspect that if you say “neutrality” to most religious liberty scholars, the first thing that they think of is Philip Kurland and a ban on religious classifications.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Formal neutrality sounds highly plausible until you think through its implications. Its simplicity and apparent even-handedness are appealing. It can explain some important cases, including my argument for the constitutionality of the Equal Access Act.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yet formal neutrality has been almost universally rejected."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.11.22",
      "id": "ft11.22"
    }
  }, [_vm._v("22")])]), _vm._v(" No major commentator endorsed it for a generation, and no case has adopted it, although many cases and commentators have applied part of it to particular problems. Now an endorsement has come from a most unlikely source, Professor Mark Tushnet."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.11.23",
      "id": "ft11.23"
    }
  }, [_vm._v("23")])]), _vm._v(" Hardly anyone else has been willing to apply it universally, because it produces surprising results that are inconsistent with strong intuitions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The most striking example is historical. The National Prohibition Act forbad the sale or consumption of alcoholic beverages in the United States, but it exempted the use of sacramental wine."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.11.24",
      "id": "ft11.24"
    }
  }, [_vm._v("24")])]), _vm._v(" Under formal neutrality, the "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("exemption was unconstitutional. The exemption undeniably classified on the basis of religion. It was lawful to consume alcohol in religious ceremonies, but not otherwise.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Now consider Prohibition without the exemption. There would be no violation of formal neutrality; religion would not even be mentioned in the statute. But it would be a crime to celebrate the Eucharist or the Seder. If the free exercise of religion includes anything beyond bare belief, it must be the right to perform the sacred rituals of the faith. A law enacted largely at the behest of Protestants that barred the sacred rites of Catholics and Jews, a law that changed the way these rites had been performed for millennia, could not be reconciled with any concept of religious liberty worthy of the name. That the law was formally neutral and enacted for a secular purpose would be no comfort to the victims.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("But facial neutrality would be dispositive to the Supreme Court of the United States. In a stunning opinion handed down after this lecture was delivered, the Court said that government may regulate the Mass for good reasons, bad reasons, or no reasons at all, so long as the regulation is facially neutral and does not single out religion."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.12.25",
      "id": "ft12.25"
    }
  }, [_vm._v("25")]), _vm._v(" The Court held that criminal punishment of the central religious ritual of an ancient faith raises no issue under the Free Exercise Clause and requires no governmental justification whatever! The example that I chose because I thought it was beyond reasonable argument has now been decided the other way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Prohibition as applied to sacramental wine is the exemplar of a large class of cases, in which the exercise of religion requires exemption from laws of general applicability. Such exemptions are now a matter of legislative grace. The Court did not go all the way to Professor Kurland’s ban on exemptions for religious exercise. Rather, it said that the Constitution is indifferent to such exemptions—that legislatures may grant or refuse exemptions as they choose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I will return to the problem of exemptions for religious conduct. For now, I note only that formal neutrality would permit a state to ban the Mass. If it produces such an implausible result in a case at the core of religious exercise, the principle is not off to a good start.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the Prohibition example, formal neutrality seems to trample religion. But formal neutrality also produces results that many Americans find unacceptably favorable to religion. Consider the case of financial aid to private education. Under formal neutrality, government can give unlimited amounts of "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("unrestricted aid to religious schools, so long as the aid goes to all schools and not to religious schools alone. But formal neutrality does not stop there. Any aid to secular private schools must be given to religious schools, on exactly the same terms. To exclude religious schools from the aid program, or to impose restrictions on religious uses of the money, would be to classify on the basis of religion. That would violate formal neutrality.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I do not think that this implication of formal neutrality is beyond the range of reasonable debate. Indeed, I think it captures an important insight. But I also believe that at least some of its results would be unconstitutional.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Stricter separationists react much more strongly. To many American separationists, the possibility that government could fully fund religious education must seem as preposterous as the banning of the Mass. This implication of formal neutrality is wildly inconsistent with the Supreme Court’s cases and with dominant understandings of the Establishment Clause."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.13.26",
      "id": "ft13.26"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As these two examples make clear, formal neutrality has something to offend everybody. As a general standard, it appeals to none of the competing factions in Religion Clause litigation. But it has had disproportionate influence on our understanding of what it means to be neutral.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.4"
    }
  }, [_c('strong', [_vm._v("III. Substantive Neutrality")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("My understanding of neutrality is quite different. Again because we need a label, I will call my proposal “substantive neutrality.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My basic formulation of substantive neutrality is this: the Religion Clauses require government to minimize the extent to which it either encourages or discourages religious belief or disbelief, practice or nonpractice, observance or nonobservance."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.13.27",
      "id": "ft13.27"
    }
  }, [_vm._v("27")])]), _vm._v(" If I have to stand or fall on a single formulation of neutrality, I will stand or fall on that one. But I must elaborate on what I mean by minimizing encouragement and discouragement. I mean that religion is to "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("be left as wholly to private choice as anything can be. It should proceed as unaffected by government as possible. Government should not interfere with our beliefs about religion either by coercion or by persuasion. Religion may flourish or wither; it may change or stay the same. What happens to religion is up to the people acting severally and voluntarily; it is not up to the people acting collectively through government.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("This elaboration highlights the connections among religious neutrality, religious autonomy, and religious voluntarism."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.14.28",
      "id": "ft14.28"
    }
  }, [_vm._v("28")]), _vm._v(" Government must be neutral so that religious belief and practice can be free. The autonomy of religious belief and disbelief is maximized when government encouragement and discouragement is minimized. The same is true of religious practice and refusal to practice. The goal of maximum religious liberty can help identify the baseline from which to measure encouragement and discouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My conception of religious neutrality includes a neutral conception of religion. That is, any belief about God, the supernatural, or the transcendent, is a religious belief. For constitutional purposes, the belief that there is no God, or no afterlife, is as much a religious belief as the belief that there is a God or an afterlife. It is a belief about the traditional subject matter of religion, and it is a belief that must be accepted on faith, because it is not subject to empirical investigation. Serious believers and serious disbelievers are sometimes troubled by this equation of their belief systems, but we cannot make sense of the Religion Clauses without it. This constitutional conception of religious belief as any belief about religion explains why atheists are protected from persecution,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.14.29",
      "id": "ft14.29"
    }
  }, [_vm._v("29")])]), _vm._v(" and why the government cannot establish atheism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Similarly, the deeply held conscientious objection of a non-theist must be treated equally with a similar objection rooted in a more traditional faith. As a plurality of the Supreme Court put it in a statutory context, the relevant category is “all those whose consciences … would give them no rest or peace” if they were compelled to comply with government policy."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.14.30",
      "id": "ft14.30"
    }
  }, [_vm._v("30")])]), _vm._v(" To be sure, there are difficulties in applying that standard to non-traditional sources of conscience. But in a nation with millions of non-believers, no other conception of conscientious objection is even plausibly neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("That is a bare sketch of substantive neutrality. The next step is to compare and contrast formal and substantive neutrality. Sometimes the two types of neutrality produce the same result. That is, sometimes we can minimize encouragement or discouragement to religion by ignoring the religious aspects of some behavior and treating it just like some analogous secular behavior.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But often the two understandings of neutrality diverge. Government routinely encourages and discourages all sorts of private behavior. Under substantive neutrality, these encouragements and discouragements are not to be applied to religion. Thus, a standard of minimizing both encouragement and discouragement will often require that religion be singled out for special treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Consider two of the examples I have mentioned so far. To prohibit the consumption of alcohol, without an exception for religious rituals, is to flatly prohibit important religious practices. Such a prohibition would discourage religious practice in the most coercive possible way—by criminalizing it. Many believers would abandon their religious practice; some would defy the law; some of those would go to jail. Such a law would be a massive departure from substantive neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To "), _c('em', [_vm._v("exempt")]), _vm._v(" sacramental wine is not perfectly neutral either. Religious observers would get to do something that is forbidden to the rest of the population, but that observation goes to formal neutrality. Would this special treatment encourage religion? It is conceivable that the prospect of a tiny nip would encourage some desperate folks to join a church that uses real wine, or to attend Mass daily instead of weekly or only at Easter. It is conceivable, but only to a law professor or an economist. Such an exemption would have only an infinitesimal tendency to encourage religious activity. In contrast, withholding the exemption would severely discourage religious activity. The course that most nearly approaches substantive neutrality—the course that minimizes both encouragement and discouragement—is to single out religious uses for an exemption. In this and similar applications, substantive neutrality is akin to the equal impact, equal outcome side of the affirmative action debate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Prohibition is an easy case under formal neutrality, and an easy case under substantive neutrality. The difference is that substantive neutrality gets the right answer. Formal neutrality, as applied to Prohibition, would lead directly to religious persecution.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Sometimes the two concepts of neutrality seem to converge. In the equal access controversy, I argued that substantive neutrality was best achieved by something close to formal neutrality—that student religious groups should ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("be treated like any other student extracurricular group."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.16.31",
      "id": "ft16.31"
    }
  }, [_vm._v("31")]), _vm._v(" To give them special privileges would encourage religion; to exclude them would discourage religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But even in that example, some deviations from formal neutrality were required. Most student extracurricular groups have a faculty sponsor, but it is widely agreed that a student religious group should not have a faculty sponsor."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.16.32",
      "id": "ft16.32"
    }
  }, [_vm._v("32")])]), _vm._v(" To say that the school will sponsor any student group except a religious group is to classify on the basis of religion. Withholding the faculty sponsor violates formal neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The school prayer cases"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.16.33",
      "id": "ft16.33"
    }
  }, [_vm._v("33")])]), _vm._v(" are the most obvious source of our intuition that public schools should not provide faculty sponsors to student religious groups. But substantive neutrality can explain that intuition. School sponsorship of a religious group commits the government to the success of a religious group, thus encouraging religion and violating substantive neutrality. Moreover, the faculty sponsor will inevitably influence the group’s conduct, thus encouraging some forms of religious practice and discouraging others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is true that religious groups are in some sense discouraged by being forced to organize and function without the school sponsorship available to all other student groups. But withholding the sponsor does not actively harm religious groups; it does not reduce or divert their own resources, or create obstacles for them to overcome. It merely withholds an intrusive benefit that is widely available to other groups that are in some ways analogous. The hoped-for benefit may turn out to be seriously harmful if the government sponsor changes the course of the religious organization. Withholding this risky benefit is not perfectly neutral, but the deviation from neutrality is considerably smaller than the deviations inherent in sponsorship. Thus, the closest the schools can come to substantive neutrality is to leave such groups alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Prohibition and equal access are simple examples. I have not yet gotten to the hard cases, like public aid to religious schools. But even these simple cases illustrate some important points about substantive neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Most obviously, substantive neutrality is harder to apply than formal neutrality. It requires judgments about the relative significance of various encouragements and discouragements to religion. Absolute zero is no more attainable in encouragement and discouragement than in temperature. We can aspire only to minimize encouragement and discouragement. Because substantive neutrality requires more judgment than formal neutrality, substantive neutrality is more subject to manipulation by advocates and result-oriented judges and law professors.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More important, substantive neutrality requires a baseline from which to measure encouragement and discouragement. What state of affairs is the background norm from which to judge whether religion has been encouraged or discouraged? This question also requires judgment; there is no simple test that can be mechanically applied to yield sensible answers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A conceivable mechanical standard is to treat religion as though government did not exist. If religion is better off than if government did not exist, it has been encouraged; if it is worse off, it has been discouraged. The only thing to recommend this standard is its intellectual purity; I doubt that it appeals to anyone in the real world.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("To take the most obvious example, no one suggests that churches be denied police and fire protection. Police and fire protection are sometimes explained as merely incidental benefits."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.17.34",
      "id": "ft17.34"
    }
  }, [_vm._v("34")]), _vm._v(" But to what are they incidental? I am not at all sure that police and fire protection arise as an incident of something else. These services are not incidental; they are provided outright and for their own sake. One might say that police and fire protection for churches is incidental to police and fire protection for everybody else, or for all property in the community. But it is easy to imagine either isolated or concentrated religious properties that would strain that rationale to the breaking point. That rationale also fails to explain why we protect churches against vandalism, embezzlement, and other property crimes that pose no threat to the neighbors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of the Supreme Court’s better opinions on incidental benefits answers the question I have posed. A permissible benefit is one that is incidental to a larger policy of neutrality."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.17.35",
      "id": "ft17.35"
    }
  }, [_vm._v("35")])]), _vm._v(" The benefits of police and fire protection are such an incident of neutrality. Police and fire protection are such a universal part of our lives that they have become part of the baseline. To deny police and fire protection would be to outlaw religion in the original sense of that word—to put religion outside the protection of the law. To demand that "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("churches provide their own police and fire protection in a modern society would be to place an extraordinary obstacle in their way—a discouragement that would make religion a hazardous enterprise indeed. To provide such services does not make religion attractive to anyone who is not attracted on the merits. As a practical matter, any encouragement is tiny. The discouraging effect of cutting off basic services greatly exceeds the encouraging effect of providing them.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Similar judgments about the baseline level of government activity are at the heart of the equal access controversy. To deny religious groups a faculty sponsor is neutral in the sense of leaving such groups where they would be if government did not exist. But if government did not exist, there would be no public schools and no classrooms in which groups could meet. The opponents of equal access argued that use of the classroom was a benefit—an encouragement in the terms I have been using—that violated the Establishment Clause."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.18.36",
      "id": "ft18.36"
    }
  }, [_vm._v("36")]), _vm._v(" The supporters of equal access argued that once classrooms were made available to other extracurricular groups, the use of the room was part of the baseline—a background norm that both religious and secular groups could take for granted."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.18.37",
      "id": "ft18.37"
    }
  }, [_vm._v("37")])]), _vm._v(" Most of the opponents seemed to concede that religious groups could use the streets and parks on an equal basis."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.18.38",
      "id": "ft18.38"
    }
  }, [_vm._v("38")])]), _vm._v(" Streets and parks are in the baseline by common consent; faculty sponsors are not in the baseline; classrooms are controversial.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The proper background norm about public facilities is related to the background norm about student behavior. If the norm is that students can generally do what they want on their own time, subject only to restraints on harmful or disruptive behavior, then banning religious groups is discouragement. But if the norm is that high school students can do nothing without school sponsorship, then allowing meetings looks like sponsorship, and even endorsement, and excluding them from campus can be characterized as the neutral course of simply declining to sponsor them. Opponents of equal access have seriously made this argument."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.18.39",
      "id": "ft18.39"
    }
  }, [_vm._v("39")])]), _vm._v(" Supporters of equal access have looked to basic First Amendment principles, and to student free speech cases not involving religion—to cases involving war protest and underground newspapers. They argued that the relevant "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("constitutional norm was that unsponsored students could say what they wanted on school premises."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.19.40",
      "id": "ft19.40"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unless we carefully think through such issues, we will tend to select our baselines by intuition, and we will give free rein to our political preferences and our prejudices. Our preferences can operate freely because the principle of neutrality by itself is insufficient to define the baseline. Judgments about the state of the world must be brought to bear. Equally important, the other principles of the Religion Clauses must be brought to bear. We must keep in mind what neutrality is supposed to accomplish. Our goal is not to leave religion in a Hobbesian state of nature, nor to leave it regulated exactly to the extent that commercial businesses are regulated, with no extra burdens and no exemptions. Our goal is to maximize the religious liberty of both believers and nonbelievers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I will return to the difficult problems of justifying and implementing substantive neutrality. But first, I want to briefly introduce a third way in which neutrality has been invoked.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.5"
    }
  }, [_c('strong', [_vm._v("IV. Disaggregated Neutrality")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The Supreme Court is rarely content with a broad principle if it can substitute a three-part test."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.19.41",
      "id": "ft19.41"
    }
  }, [_vm._v("41")])]), _vm._v(" Its most famous formulation of the neutrality requirement is the second part of the "), _c('em', [_vm._v("Lemon")]), _vm._v(" test, which says that a law violates the Establishment Clause if one of its substantial effects is either to advance or inhibit religion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.19.42",
      "id": "ft19.42"
    }
  }, [_vm._v("42")])]), _vm._v(" This formulation began simply as an elaboration of neutrality,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.19.43",
      "id": "ft19.43"
    }
  }, [_vm._v("43")])]), _vm._v(" but is often disaggregated into a test of no advancement and a separate test of no inhibition. If a law has some substantial effect that advances religion, that may be the end of the case. And there is sometimes a very low threshold for finding effects to be substantial.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the extreme case of "), _c('em', [_vm._v("Aguilar v. Felton")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.19.44",
      "id": "ft19.44"
    }
  }, [_vm._v("44")])]), _vm._v(" the Supreme Court invalidated a federal program to provide remedial instruction in math and reading to low income children in private schools. Congress enacted this program in "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("pursuit of neutrality—to provide the same remedial program to disadvantaged children without regard to their religious choices. Why did the Court strike it down? Because the public employees who provided the remedial instruction might be influenced by the religious environment of parochial schools, and under that hypnotic influence, might encourage the children to religious belief."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.45",
      "id": "ft20.45"
    }
  }, [_vm._v("45")]), _vm._v(" That possibility created a risk of a substantial effect of advancing religion; that risk could be avoided only by close supervision that would excessively entangle church and state."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.46",
      "id": "ft20.46"
    }
  }, [_vm._v("46")])]), _vm._v(" That was the end of the case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I call this disaggregated neutrality, because it looks only at one side of the balance of advancing or inhibiting. Because absolute zero is not achievable, it is always possible to find some effect of advancing or inhibiting religion. Thus, if you look only at one side of the balance, you can always find a constitutional violation. Some of those who would have government sponsor their faith play the same game on the inhibits side of the balance: if government does not lead school children in prayer, or display religious symbols on major holidays, the public may infer that government is hostile to religion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.47",
      "id": "ft20.47"
    }
  }, [_vm._v("47")])]), _vm._v(" Therefore, these critics conclude, silence is not neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Substantive neutrality always requires that the encouragement of one policy be compared to the discouragement of alternative policies. The principal effect of "), _c('em', [_vm._v("Aguilar")]), _vm._v(" was to greatly increase the cost of providing remedial programs to children in private schools."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.48",
      "id": "ft20.48"
    }
  }, [_vm._v("48")])]), _vm._v(" After "), _c('em', [_vm._v("Aguilar")]), _vm._v(", the government or the school must provide separate off-campus facilities and the children must travel to those facilities and back again. The effect of increasing the cost was to reduce the number of children who could be served. So thousands of our least advantaged citizens are now forced to choose: forfeit their right to remedial instruction in math and reading, or forfeit their right to education in a religious environment. That effect discourages religion, and dwarfs the risk that the government’s remedial math or reading teacher might suddenly start "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("proselytizing. By disaggregating neutrality, the Court has lost sight of its original objective.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another way to disaggregate neutrality is to shift back and forth among different versions of neutrality without explanation. If you think that neutrality with respect to government-imposed burdens means that churches and believers never get an exemption (formal neutrality), but that neutrality with respect to government benefits means that churches can never participate (disaggregated substantive neutrality), you had better have a good explanation. The most obvious explanation is simply hostility to religion. If you have the opposite preferences, you are equally in need of a good explanation.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Voting patterns in the Supreme Court are often disaggregated, sometimes in suspicious ways. Justice Brennan applied formal neutrality to strike down a legislative tax exemption in "), _c('em', [_vm._v("Texas Monthly, Inc.")]), _vm._v(","), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.49",
      "id": "ft21.49"
    }
  }, [_vm._v("49")]), _vm._v(" and he applied disaggregated neutrality to strike down the remedial education program in "), _c('em', [_vm._v("Aguilar.")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.50",
      "id": "ft21.50"
    }
  }, [_vm._v("50")])]), _vm._v(" But he believes the Constitution "), _c('em', [_vm._v("requires")]), _vm._v(" exemptions from laws that violate religious conscience, a position consistent with substantive neutrality."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.51",
      "id": "ft21.51"
    }
  }, [_vm._v("51")])]), _vm._v(" Justice Rehnquist takes the opposite position on all three of these issues."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.52",
      "id": "ft21.52"
    }
  }, [_vm._v("52")])]), _vm._v(" Justice Stevens agrees with Brennan on tax exemptions"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.53",
      "id": "ft21.53"
    }
  }, [_vm._v("53")])]), _vm._v(" and aid to religious schools,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.54",
      "id": "ft21.54"
    }
  }, [_vm._v("54")])]), _vm._v(" but with Rehnquist on exemptions for conscience."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.55",
      "id": "ft21.55"
    }
  }, [_vm._v("55")])]), _vm._v(" Stevens votes against traditional religions on all three issues, an odd interpretation of religious liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the Term since this lecture was delivered, the Court has dramatically embraced formal neutrality to uphold taxation and regulation of churches and believers."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.56",
      "id": "ft21.56"
    }
  }, [_vm._v("56")])]), _vm._v(" In "), _c('em', [_vm._v("Jimmy Swaggart Ministries")]), _vm._v(", the Court unanimously held that churches can be taxed, so long as the tax laws do not single out churches for discriminatory rates or incidents of taxation. The Court in dictum suggested that it would apply the same standard to regulation of churches, except "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("where compliance with the regulation would require the church to violate its “sincere religious beliefs.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.57",
      "id": "ft22.57"
    }
  }, [_vm._v("57")]), _vm._v(" In "), _c('em', [_vm._v("Employment Division v. Smith")]), _vm._v(", the exception for sincere religious belief disappeared by a vote of five to four."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.58",
      "id": "ft22.58"
    }
  }, [_vm._v("58")])]), _vm._v(" The free exercise of religion now means that churches cannot be taxed or regulated any more heavily than General Motors. The only remaining protection is that provided by formal neutrality; religious conduct cannot be singled out for facially discriminatory regulation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court recognized that these holdings burdened the exercise of religion. The "), _c('em', [_vm._v("Smith")]), _vm._v(" opinion acknowledged that the conduct at issue was “the ‘exercise of religion,’ ”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.59",
      "id": "ft22.59"
    }
  }, [_vm._v("59")])]), _vm._v(" and that Oregon had subjected this conduct to “an across-the-board criminal prohibition,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.60",
      "id": "ft22.60"
    }
  }, [_vm._v("60")])]), _vm._v(" but it insisted that this prohibition of an exercise of religion did not mean that Oregon was “prohibiting the free exercise of religion.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.61",
      "id": "ft22.61"
    }
  }, [_vm._v("61")])]), _vm._v(" In "), _c('em', [_vm._v("Swaggart")]), _vm._v(", the Court said that the economic burden of paying the tax, and “substantial administrative burdens” of collecting the tax or complying with other regulations, were “not constitutionally significant.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.62",
      "id": "ft22.62"
    }
  }, [_vm._v("62")])]), _vm._v(" The Court found it “undeniable that a generally applicable tax has a secular purpose and neither advances nor inhibits religion, for the very essence of such a tax is that it is neutral and nondiscriminatory on questions of religious belief.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.22.63",
      "id": "ft22.63"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This conception of neutrality is irreconcilable with "), _c('em', [_vm._v("Aguilar")]), _vm._v(" and the other cases striking down government payments to religiously affiliated schools. In "), _c('em', [_vm._v("Aguilar")]), _vm._v(", the federally-funded instruction in remedial math and reading was directed on equal terms to poor children in all schools, public and private, secular and religious. But the Court did not say that this “neutral and nondiscriminatory” instruction “neither advances nor inhibits religion.” Instead, it found that the government money conferred obvious benefits on religion, and did not say that those benefits were of no constitutional significance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Court’s current position comes to this: when government demands money or obedience "), _c('em', [_vm._v("from")]), _vm._v(" churches, neutrality consists of treating churches just like other subjects of taxation or regulation, and it is irrelevant that the church is worse off than it would be without the tax or the regulation. But when government pays money "), _c('em', [_vm._v("to")]), _vm._v(" churches, neutrality consists of not making the churches any better off than they would be without the payment, and it is "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("irrelevant that the churches are treated just like other beneficiaries of the same program.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whatever explains these results, it is not a consistent understanding of neutrality. I suspect that the Justices are not deciding on the basis of neutrality at all, although they invoke it in their opinions. If they are deciding on the basis of neutrality, they have not defined it in any consistent way. But the inconsistency of the current rules may be only a transitional step on the way to widespread application of formal neutrality as the rule of judicial decision.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The current rules may result from a temporary voting paradox. Justices Brennan, Marshall, and Blackmun would restrict both regulation of religion and government support of religion. Justices Rehnquist, White, Scalia, and Kennedy would generally permit both regulation and support of religion. Justice O’Connor is a swing vote on both regulation and support. For all eight of these Justices, their votes in Religion Clause cases are best explained by their general attitudes toward judicial enforcement of constitutional rights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Justice Stevens is the exception. He votes with the judicial activists on most issues, including the Establishment Clause, but he joins the judicial minimalists in free exercise cases. The apparent explanation for his voting pattern is hostility to religion. Religion in his view is subject to all the burdens of government, but entitled to few of the benefits. And because the Court has been closely divided between activist and minimalist judges, he has been a swing vote on religion issues. His hostility to religion is reflected in the Court’s rules, even though he has but one vote.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Aguilar")]), _vm._v(", the decision striking down federally-funded remedial instruction in religious schools, was a five-four decision in 1985. Justices Scalia and Kennedy have replaced Burger and Powell, and it is a reasonable guess that if it came up today, "), _c('em', [_vm._v("Aguilar")]), _vm._v(" would be five-four the other way. We may soon see a formal neutrality opinion upholding government aid to religious education.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("That hypothetical development would greatly reduce the inconsistencies in the Court’s opinions. But it would not be a triumph for neutrality. Legislatures would be free to practice disaggregated formal neutrality. They could support religion or burden it, support some religions and burden others, as long as they stated their rules in facially neutral terms. The Court in "), _c('em', [_vm._v("Smith")]), _vm._v(" acknowledged somewhat euphemistically that its decision “will place at a relative disadvantage those religious practices that are not widely engaged in.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.23.64",
      "id": "ft23.64"
    }
  }, [_vm._v("64")]), _vm._v(" In plain English, this means that churches without political clout may be suppressed, that more powerful churches may be accommodated, "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("and if the principle is extended to the financial aid cases, they may be supported. If the Court’s decisions are eventually reconciled in this way, the explanatory principle will not be neutrality, but statism. The majority will be permitted to do anything it can achieve by facially neutral rules, however gerrymandered, and the Court will have largely abdicated its role of protecting religious minorities.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.6"
    }
  }, [_c('strong', [_vm._v("V. Applying Substantive Neutrality")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Formal and substantive neutrality are broad categories. But as I noted earlier, religious liberty controversies present a succession of specific problems. It is necessary to search out the most neutral course with respect to each problem. That process will at least clarify our disagreements, and it might provide some basis for principled argument to legislatures and state courts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Recall my distinction between equality and neutrality: equality refers only to tangible penalties and rewards; neutrality also includes expression of government opinion. It seems to me that we have widespread consensus on both equality and neutrality with respect to religious status, consensus on equality but not on neutrality with respect to religious belief, consensus except for a few exceptional cases with respect to religious speech, and no consensus at all with respect to religious conduct.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("That is a glib set of categories; what do I mean by them? First, consensus with respect to status: almost no one any longer openly claims that nonbelievers, or non-Christians, or non-Protestants, should be discriminated against because of their religious affiliation. There are occasional exceptions, such as the recent attacks on Father Healy’s appointment to head the New York Public Library."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.24.65",
      "id": "ft24.65"
    }
  }, [_vm._v("65")]), _vm._v(" But these attacks are nearly always disguised with "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("pretextual justifications. Moreover, hardly anyone thinks it a proper function of government to denounce the adherents of some religious faiths and laud the adherents of others.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Second, partial consensus with respect to religious belief: we have consensus on equality; no one argues that government should actively penalize some religious beliefs and reward others. But we do not have consensus on neutrality. A vocal minority of lawyers and scholars,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.25.66",
      "id": "ft25.66"
    }
  }, [_vm._v("66")]), _vm._v(" and perhaps a majority of the public,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.25.67",
      "id": "ft25.67"
    }
  }, [_vm._v("67")])]), _vm._v(" believe that government may endorse a preferred religious belief. Some urge generic theism, some the Judeo-Christian tradition, some Christianity. Whatever their preferred teaching, these people reject the Supreme Court’s holdings that government should be neutral with respect to religious belief. And of course, the Supreme Court itself does not seem to take those holdings very seriously."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.25.68",
      "id": "ft25.68"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third, partial consensus with respect to religious speech: religious speech and political speech are the two core cases of highly protected speech, and they should be treated equally. A long line of Supreme Court cases are consistent with that proposition,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.25.69",
      "id": "ft25.69"
    }
  }, [_vm._v("69")])]), _vm._v(" and I think there is widespread agreement with those results, although not necessarily with my formulation of the principle. Religious speech in and around public schools is an exceptional case where consensus breaks down. Consensus also breaks down when money is involved, as in the "), _c('em', [_vm._v("Texas Monthly")]), _vm._v(" case, in the campaign finance and disclosure laws,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.25.70",
      "id": "ft25.70"
    }
  }, [_vm._v("70")])]), _vm._v(" and in the restrictions on political speech in the "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Internal Revenue Code."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.26.71",
      "id": "ft26.71"
    }
  }, [_vm._v("71")]), _vm._v(" My principle that religious and political speech should be treated equally could have explained the "), _c('em', [_vm._v("Texas Monthly")]), _vm._v(" case, and my principle had some relation to the discordant and troublesome combination of opinions that made up the majority. The more recent decision in "), _c('em', [_vm._v("Jimmy Swaggart Ministries")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.26.72",
      "id": "ft26.72"
    }
  }, [_vm._v("72")])]), _vm._v(" makes it harder to sustain benign readings of "), _c('em', [_vm._v("Texas Monthly.")]), _vm._v(" But it remains open to the Court to uphold a tax exemption that includes religious speech in some broader category, such as not-for-profit speech, or religious, anti-religious, and political speech. The relationship between constitutional protections for religious and political speech is now before the Court in the quite different context of judgments against churches for such speech torts as defamation and intentional infliction of emotional distress."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.26.73",
      "id": "ft26.73"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Finally, dissensus with respect to religious conduct. What does it mean to be neutral with respect to conscientious objection to government policy, or religious education, or religious charities, or the management of religious institutions? I am not sure we have consensus that either equality or neutrality is required with respect to religious conduct; we certainly have no consensus on what that means.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Allow me to consider just one of these examples, exemption from facially neutral laws that forbid religious conduct or require people to violate deeply held conscientious beliefs. The Supreme Court repeatedly announced the constitutional right to such exemptions, but enforced it half-heartedly."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.26.74",
      "id": "ft26.74"
    }
  }, [_vm._v("74")])]), _vm._v(" The "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Reagan Administration quietly hammered at that right for eight years."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.75",
      "id": "ft27.75"
    }
  }, [_vm._v("75")]), _vm._v(" Now the Court has wholly repudiated the right."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.76",
      "id": "ft27.76"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Scholars are also attacking the right to exemption, often in the name of neutrality. Two major scholars have recently offered all-out attacks on the constitutional right to such exemptions. One is Ellis West, a political scientist at the University of Richmond;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.77",
      "id": "ft27.77"
    }
  }, [_vm._v("77")])]), _vm._v(" the other is William Marshall, a lawyer at Case Western Reserve."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.78",
      "id": "ft27.78"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Neither the scholars or the Court goes as far as requiring formal neutrality."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.79",
      "id": "ft27.79"
    }
  }, [_vm._v("79")])]), _vm._v(" Neither claims that exemptions for religion are unconstitutional when the legislature voluntarily grants them. Both rely on the formal conception of neutrality, but both draw back from its full implications, or at least from the claim that it is constitutionally required.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("They do not appear to flinch from the full implications of their claim that the Constitution requires no exemptions for religious exercise. I assume that they would permit a state to enact Prohibition without an exception for the Mass or the Seder. The Court says as much in its opinion,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.80",
      "id": "ft27.80"
    }
  }, [_vm._v("80")])]), _vm._v(" and Professor West said as much in response to a question."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.81",
      "id": "ft27.81"
    }
  }, [_vm._v("81")])]), _vm._v(" He also said that if a law forbidding ethnic and religious discrimination in employment had no exception "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("for rabbis, then a synagogue might have to hire a Baptist rabbi. He defended himself on the ground that no state would pass such a law, and that probably the Baptist would be unqualified on some other ground."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.82",
      "id": "ft28.82"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The hope that no state would pass such a law is insufficient protection for religious minorities. It is true that Americans are more tolerant than many other populations, in part because of the teachings of the Religion Clauses. Many religious minorities have assimilated into the general culture and into the political process, and the legislature is unlikely to knowingly victimize these minorities in ways that go to the heart of their faith. That is why Jews and Catholics were protected by an exception to Prohibition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But the precondition of assimilation and respectability is why Oregon has failed to protect Native Americans’ ritual use of peyote."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.83",
      "id": "ft28.83"
    }
  }, [_vm._v("83")])]), _vm._v(" This social precondition is why in the nineteenth century we denied Mormons the right to vote,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.84",
      "id": "ft28.84"
    }
  }, [_vm._v("84")])]), _vm._v(" imprisoned some of their leaders,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.85",
      "id": "ft28.85"
    }
  }, [_vm._v("85")])]), _vm._v(" confiscated all the property of their church,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.86",
      "id": "ft28.86"
    }
  }, [_vm._v("86")])]), _vm._v(" and dissolved its legal existence,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.87",
      "id": "ft28.87"
    }
  }, [_vm._v("87")])]), _vm._v(" until the church changed its practice, its teaching, and its belief on plural marriage."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.88",
      "id": "ft28.88"
    }
  }, [_vm._v("88")])]), _vm._v(" This social precondition is why multi-million-dollar tort judgments threaten the very existence of the Hare Krishnas, the Scientologists, and other so-called “cults.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.28.89",
      "id": "ft28.89"
    }
  }, [_vm._v("89")])]), _vm._v(" I am not much comforted by the prospect that only small and unfamiliar religions will be persecuted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nor am I willing to assume that larger religious minorities are always safe. The Church of Christ is hardly a fringe group in Collinsville, Oklahoma, but it too is threatened with destruction from a huge tort judgment for intangible "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("harm to a disgruntled former member."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.29.90",
      "id": "ft29.90"
    }
  }, [_vm._v("90")]), _vm._v(" In this decade, the military attempted to eliminate Jewish officers who wore their yarmulke while in uniform. In what appeared to be a fit of unthinking deference, the Supreme Court upheld that practice."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.29.91",
      "id": "ft29.91"
    }
  }, [_vm._v("91")])]), _vm._v(" Congress intervened with protective legislation,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.29.92",
      "id": "ft29.92"
    }
  }, [_vm._v("92")])]), _vm._v(" but much harm had been done in the meantime. In retrospect, the Court’s refusal to protect yarmulkes was a precursor to its refusal in "), _c('em', [_vm._v("Smith")]), _vm._v(" to protect any religious conduct at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In times of political excitement, of xenophobia, of outbursts of anti-Catholic or anti-Semitic feeling, almost any kind of law is possible, especially at the state and local level. The question is not merely what the federal government might do in such times, although that is scary enough. It was Congress that persecuted the Mormons, and the federal executive that tried to purge observant Jewish military officers. But we must also consider what state and local jurisdictions with religiously homogeneous populations might do to small and unfamiliar minorities. The point is not that such populations are any less enlightened than other Americans, but simply that the forces of pluralism are more attenuated in homogenous communities. What might Utah, or Arkansas, or Yalobusha County do in times of excitement? We have a bill of rights to be enforced by an independent judiciary in part to get us through such times with minimal damage. To claim that the worst horror stories are unlikely to happen is to miss the point of a bill of rights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I start with overt hostility because it would be a mistake to assume it away. But hostility is not the only source of law forbidding people to practice their religions, and probably not even the most important. The practice of a small faith may be forbidden just because the legislature did not know about it and never considered its needs. Then the bureaucracy will grind forward, enforcing the rule without regard to exceptional circumstance. This may be what happened to Frances Quaring, who thought the picture on her driver’s license was a graven image forbidden by the second commandment."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.29.93",
      "id": "ft29.93"
    }
  }, [_vm._v("93")])]), _vm._v(" The Frances Quarings of the world may or may not be organized enough to get the attention of the legislature, but a court is required to listen to their complaint and to rule one way or the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of course, inadvertence can interact with hostility, or with an insensitivity that borders on hostility. Consider what might happen when Frances "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Quaring writes her legislator. She may get a sympathetic response and a legislated exemption. But her legislator may find it so impossible to empathize with her belief that he never seriously considers whether an exemption would be workable. Even if he empathizes, the legislative calendar is crowded, and the original statute having been enacted, all the burdens of legislative inertia now work against an exemption.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("For a variety of reasons, therefore, we cannot always rely on legislatures to protect minority religious conduct. Courts are not always better, but they give religious liberty claims a second chance to be heard."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.30.94",
      "id": "ft30.94"
    }
  }, [_vm._v("94")]), _vm._v(" If we take seriously the constitutional right to freely exercise religion, we must restore a judicially enforceable right to religious exemption in appropriate cases.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The right to exemptions for religious conduct is more easily explained in terms of religious liberty than in terms of neutrality. But the right is consistent with substantive neutrality, and it can be explained in those terms as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As I have already noted with respect to Prohibition, a law that penalizes religious conduct discourages religion. The discouragement is often severe, as when the penalty is criminal punishment or Frances Quaring’s loss of the right to drive. But in many of the cases, an exemption for conscientious objectors has only a de minimis tendency to encourage any aspect of religion. The exemption is substantively neutral; the lack of an exemption is not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another way to state this is that equal impact comes closer to the proper sense of neutrality with respect to conscientious objection. People with a deeply held conscientious objection to a law are not similarly situated to people without such an objection. To insist on formally equal treatment of objectors and non-objectors is to pursue the same majestic equality that forbids the rich and the poor alike to sleep under bridges."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.30.95",
      "id": "ft30.95"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Substantive equality and equal impact are not wholly equivalent. The difference between them appears in cases where religious belief coincides too closely with self-interest, as in conscientious objection to military service or payment of taxes. The distorting effects of self-interest do not make sincere conscientious objectors similarly situated with non-objectors; denying the exemption still has severe and unequal impact on objectors. The equal impact sense of neutrality would focus on the objectors and presumptively "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("grant the exemption, subject only to the government’s proof of a compelling reason to deny it.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("But substantive neutrality as I have defined it must also consider the non-objectors. If we grant exemptions from military service or general taxation, on the basis of conscientious objection, we will inevitably encourage religion. I do not refer to the people willing to feign religious belief in order to claim an exemption. There may be millions of these people, and the difficulty of adjudicating their false claims is relevant to the government’s claim of compelling interest,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.31.96",
      "id": "ft31.96"
    }
  }, [_vm._v("96")]), _vm._v(" but these false claimants are only incidentally relevant to neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I refer instead to the people who honestly persuade themselves that they have come to hold the religious belief that entitles them to the exemption, or who feel pressured to adopt that belief. Human nature being what it is, there may be millions of these people as well. The lure of exemption creates cognitive dissonance between the individual’s desire for the exemption and the belief that makes him ineligible for it. The psychological effort to reduce this dissonance can move his actual belief into conformity with the belief that serves his self-interest."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.31.97",
      "id": "ft31.97"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The problem for religious neutrality is that denying the exemption discourages religious belief in one set of people, and granting the exemption encourages religious belief in another, overlapping, set of people. It is no longer clear that exemption is the more nearly neutral course. If we suspect that the original number of conscientious objectors is small, and that the number of non-objectors seriously tempted by the exemption is large, then denying the exemption appears to be more nearly neutral than granting it. If we have no plausible estimate of which effect is larger, then there may be no basis in substantive neutrality for the courts to second-guess the legislature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whatever we do in these difficult cases, the deviation from neutrality is large. Either we will deny the exemption, with severe and unequal impact on the original objectors, devastating to their religious liberty, or we will grant the exemption, and greatly encourage religious belief in the objectors induced by the exemption. The case is hard, and the most nearly neutral course will not be very neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Legislatures can sometimes solve these problems by imposing an alternative burden, designed to accommodate conscience while reducing the self-interested "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("reasons for claiming the exemption. That is part of the logic of the alternative service requirement for objectors to military service,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.32.98",
      "id": "ft32.98"
    }
  }, [_vm._v("98")]), _vm._v(" and of the requirement that workers who object to union dues make an equivalent contribution to a charity other than their church."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.32.99",
      "id": "ft32.99"
    }
  }, [_vm._v("99")])]), _vm._v(" These legislative solutions are not perfect—thousands of Jehovah’s Witnesses spent World War II in prison because they objected even to alternative service"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.32.100",
      "id": "ft32.100"
    }
  }, [_vm._v("100")])]), _vm._v("—but they permit a closer approximation to substantive neutrality. They come from thoughtful legislatures; it is harder to see how courts could create them.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "PT1.1.3.7"
    }
  }, [_c('strong', [_vm._v("VI. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("I hope I have at least persuaded you that the meaning of neutrality is not self-evident, and that substantive neutrality is a possible alternative to formal neutrality. Beyond that, I hope I have persuaded you that substantive neutrality is more consistent with religious liberty than is formal neutrality. I have much more work to do to show that a neutral baseline can usually be identified in a principled way across the whole range of interactions between religion and government. But I hope I have persuaded you that the work is worth doing. For that is the path toward maximum religious liberty, neutrally distributed among all kinds of believers and non-believers. And that multifarious formulation is as close as I can come to a single principle that summarizes the Religion Clauses.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.1",
      "id": "fn.4.1"
    }
  }, [_vm._v("1")]), _vm._v(". County of Allegheny v. American Civil Liberties Union Greater Pittsburgh Chapter, 492 U.S. 573, 589–94 (1989). Earlier cases are collected in Laycock, "), _c('em', [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")]), _vm._v(", 81 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 2 n.6 (1986). Commentators are collected in Steven D. Smith, "), _c('em', [_vm._v("Symbols, Perceptions, and Doctrinal Illusions: Establishment Neutrality and the “No Endorsement” Test")]), _vm._v(", 86 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 266, 314 n.183 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.2",
      "id": "fn.4.2"
    }
  }, [_vm._v("2")]), _vm._v(". For a clear statement of this position, "), _c('em', [_vm._v("see")]), _vm._v(" Smith, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 313–32. "), _c('em', [_vm._v("Cf.")]), _vm._v(" John T. Valauri, "), _c('em', [_vm._v("The Concept of Neutrality in Establishment Clause Doctrine")]), _vm._v(", 48 U. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITT")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 83 (1986). Valauri would keep the concept of neutrality because its appeal is “compelling,” but would restrict the Supreme Court’s power to enforce it because it is “multiply and irresolvably ambiguous.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 149, 151.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.3",
      "id": "fn.4.3"
    }
  }, [_vm._v("3")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERT")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILLER")]), _vm._v(" & R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONALD")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOWERS")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWARD")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENEVOLENT")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EUTRALITY")]), _vm._v(": C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(", S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UPREME")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURT")]), _vm._v(" (3d ed. 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.4",
      "id": "fn.4.4"
    }
  }, [_vm._v("4")]), _vm._v(". Ruti Teitel, "), _c('em', [_vm._v("When Separate Is Equal: Why Organized Religious Exercises, Unlike Chess, Do Not Belong in the Public Schools")]), _vm._v(", 81 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 174 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.5",
      "id": "fn.4.5"
    }
  }, [_vm._v("5")]), _vm._v(". 489 U.S. 1 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft4.6",
      "id": "fn.4.6"
    }
  }, [_vm._v("6")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 13 (Brennan, J.) (plurality opinion); "), _c('em', [_vm._v("id.")]), _vm._v(" at 40 (Scalia, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.7",
      "id": "fn.5.7"
    }
  }, [_vm._v("7")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.8",
      "id": "fn.5.8"
    }
  }, [_vm._v("8")]), _vm._v(". 20 U.S.C. §§ 4071–4074 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.9",
      "id": "fn.5.9"
    }
  }, [_vm._v("9")]), _vm._v(". Board of Educ. v. Mergens, 496 U.S. 226 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.10",
      "id": "fn.5.10"
    }
  }, [_vm._v("10")]), _vm._v(". Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.5"
    }
  }, [_vm._v("note 4")]), _vm._v(", at 183–89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.11",
      "id": "fn.5.11"
    }
  }, [_vm._v("11")]), _vm._v(". Geoffrey Stone, "), _c('em', [_vm._v("The Equal Access Controversy: The Religion Clauses and the Meaning of “Neutrality.”")]), _vm._v(" 81 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 168, 170–71 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.12",
      "id": "fn.5.12"
    }
  }, [_vm._v("12")]), _vm._v(". Michael McConnell, "), _c('em', [_vm._v("Neutrality Under the Religion Clauses")]), _vm._v(", 81 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("W")]), _vm._v(". U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 146, 149 n.17 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft5.13",
      "id": "fn.5.13"
    }
  }, [_vm._v("13")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Michael McConnell & Richard Posner, "), _c('em', [_vm._v("An Economic Approach to Issues of Religious Freedom")]), _vm._v(", 56 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 14 (1989) (proposing requirement of neutrality toward religion, conceived not as “treating religion just like other activities,” but as minimizing effects on religious practice); Michael McConnell, "), _c('em', [_vm._v("Unconstitutional Conditions: Unrecognized Implications for the Establishment Clause")]), _vm._v(", 26 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AN")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IEGO")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 255, 260 (1989) (government “may not redistribute wealth on the basis of an individual’s, or group’s, exercise of a constitutionally protected right, unless it can show that it has a legitimate justification for doing so”). I have learned much from what he has written. Of course, he is not responsible for anything I say in this Article.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft6.14",
      "id": "fn.6.14"
    }
  }, [_vm._v("14")]), _vm._v(". Peter Westen, "), _c('em', [_vm._v("The Empty Idea of Equality")]), _vm._v(", 95 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 537 (1982). For critical commentary, see Steven J. Burton, "), _c('em', [_vm._v("Comment on “Empty Ideas”: Logical Positivist Analyses of Equality and Rules")]), _vm._v(", 91 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 1136 (1982); Anthony D’Amato, "), _c('em', [_vm._v("Comment: Is Equality a Totally Empty Idea?")]), _vm._v(", 81 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 600 (1983); Kent Greenawalt, "), _c('em', [_vm._v("How Empty")]), _vm._v(" Is "), _c('em', [_vm._v("the Idea of Equality?")]), _vm._v(", 83 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1167 (1983); Kenneth W. Simons, "), _c('em', [_vm._v("Equality as a Comparative Right")]), _vm._v(", 65 B.U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 387 (1985). For Westen’s responses, see Peter Westen, "), _c('em', [_vm._v("To Lure the Tarantula from Its Hole: A Response")]), _vm._v(", 83 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1186 (1983); Peter Westen, "), _c('em', [_vm._v("The Meaning of Equality in Law, Science, Math & Morals: A Reply")]), _vm._v(", 81 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 604 (1983); Peter Westen, "), _c('em', [_vm._v("On “Confusing Ideas”: Reply")]), _vm._v(", 91 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 1153 (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft6.15",
      "id": "fn.6.15"
    }
  }, [_vm._v("15")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Califano v. Goldfarb, 430 U.S. 199 (1977) (invalidating different eligibility standards for widows and widowers); Weinberger v. Wiesenfeld, 420 U.S. 636 (1975) (same).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft7.16",
      "id": "fn.7.16"
    }
  }, [_vm._v("16")]), _vm._v(". "), _c('em', [_vm._v("Cf.")]), _vm._v(" Massachusetts Bd. of Retirement v. Murgia, 427 U.S. 307 (1976) (upholding mandatory retirement law); McCarthy v. Sheriff of Suffolk County, 322 N.E.2d 758 (Mass. 1975) (same).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft7.17",
      "id": "fn.7.17"
    }
  }, [_vm._v("17")]), _vm._v(". Age Discrimination in Employment Act, 29 U.S.C. §§ 621–634 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft8.18",
      "id": "fn.8.18"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Stephen Carter, "), _c('em', [_vm._v("The Best Black, and Other Tales")]), _vm._v(", 1 R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECONSTRUCTION")]), _vm._v(" 6 (1990); Drew Days, "), _c('em', [_vm._v("Turning Back the Clock: The Reagan Administration and Civil Rights")]), _vm._v(", 19 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". C.R.-C.L. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 309 (1984); Charles Fried, "), _c('em', [_vm._v("Affirmative Action After")]), _vm._v(" City of Richmond v. J.A. Croson Co.: "), _c('em', [_vm._v("A Response to the Scholars’ Statement")]), _vm._v(", 99 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 155 (1989); Randall Kennedy, "), _c('em', [_vm._v("Persuasion and Distrust: A Comment on the Affirmative Action Debate")]), _vm._v(", 99 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1327 (1987); David L. Kirp & Nancy A. Weston, "), _c('em', [_vm._v("The Political Jurisprudence of Affirmative Action")]), _vm._v(", 5 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OC")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIL")]), _vm._v(". & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" 223 (1987); Douglas Laycock, "), _c('em', [_vm._v("Taking Constitutions Seriously: A Theory of Judicial Review")]), _vm._v(" (Book Review), 59 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 343, 376–85 (1981); Glenn Loury, "), _c('em', [_vm._v("Why Should We Care About Group Inequality")]), _vm._v(", 5 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OC")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIL")]), _vm._v(". & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" 249 (1987); Bernard Meltzer, "), _c('em', [_vm._v("The Weber Case: The Judicial Abrogation of the Antidiscrimination Standard in Employment")]), _vm._v(", 47 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 423 (1980); Charles E. Mitchell, "), _c('em', [_vm._v("Race-Conscious Remedies: Pursuing Equal Employment Opportunity or Equal Employment Results?")]), _vm._v(", 38 L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AB")]), _vm._v(". L.J. 781 (1987); George Rutherglen & Daniel Ortiz, "), _c('em', [_vm._v("Affirmative Action Under the Constitution and Title VII: From Confusion to Convergence")]), _vm._v(", 35 UCLA L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 467 (1988); Martin Schiff, "), _c('em', [_vm._v("Reverse Discrimination Redefined as Equal Protection: The Orwellian Nightmare in the Enforcement of Civil Rights Laws")]), _vm._v(", 8 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". J.L. & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UB")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" 627 (1985); David A. Strauss, "), _c('em', [_vm._v("The Myth of Colorblindness")]), _vm._v(", 1986 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 99; Laurence Tribe, "), _c('em', [_vm._v("“In What Vision of the Constitution Must the Law Be Color-Blind?”")]), _vm._v(", 20 J. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARSHALL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 201 (1986); William Van Alstyne, "), _c('em', [_vm._v("Rites of Passage: Race, the Supreme Court, and the Constitution")]), _vm._v(", 46 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 775 (1979); J. Skelly Wright, "), _c('em', [_vm._v("Color Blind Theories and Color-Conscious Remedies")]), _vm._v(", 47 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 213 (1980); "), _c('em', [_vm._v("Affirmative Action")]), _vm._v(", 72 I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWA")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 255 (symposium featuring Jesse Choper, Rex Lee, and Paul Brest); Joint Statement, "), _c('em', [_vm._v("Constitutional Scholars’ Statement on Affirmative Action After")]), _vm._v(" City of Richmond v. J.A. Croson Co., 98 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 1711 (1989); "), _c('em', [_vm._v("Scholars’ Reply to Professor Fried")]), _vm._v(", 99 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 163 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft10.19",
      "id": "fn.10.19"
    }
  }, [_vm._v("19")]), _vm._v(". 485 U.S. 439 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft10.20",
      "id": "fn.10.20"
    }
  }, [_vm._v("20")]), _vm._v(". Widmar v. Vincent, 454 U.S. 263 (1981); Equal Access Act, 20 U.S.C. § 4071–4074 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft11.21",
      "id": "fn.11.21"
    }
  }, [_vm._v("21")]), _vm._v(". Philip Kurland, "), _c('em', [_vm._v("Of Church and State and the Supreme Court")]), _vm._v(", 29 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 96 (1961).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft11.22",
      "id": "fn.11.22"
    }
  }, [_vm._v("22")]), _vm._v(". See Philip Kurland, "), _c('em', [_vm._v("The Irrelevance of the Constitution: The Religion Clauses of the First Amendment and the Supreme Court")]), _vm._v(", 24 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 3, 24 (1978).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft11.23",
      "id": "fn.11.23"
    }
  }, [_vm._v("23")]), _vm._v(". Mark Tushnet, "), _c('em', [_vm._v("“Of Church and State and the Supreme Court”: Kurland Revisited")]), _vm._v(", 1989 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 373. It is surprising to find a leader of the critical legal studies movement endorsing a rule of formal neutrality, implicitly assuming that the government is not responsible for the unequal impact of its actions, and urging the virtues of clear legal doctrine.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft11.24",
      "id": "fn.11.24"
    }
  }, [_vm._v("24")]), _vm._v(". An Act to Prohibit Intoxicating Beverages, ch. 85 § 6, 41 Stat. 305, 311 (1919).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft12.25",
      "id": "fn.12.25"
    }
  }, [_vm._v("25")]), _vm._v(". Employment Div. v. Smith, 494 U.S. 872 (1990). For analysis of this case, see Douglas Laycock, "), _c('em', [_vm._v("Peyote, Wine, and the First Amendment")]), _vm._v(", 106 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTURY")]), _vm._v(" 876 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft13.26",
      "id": "fn.13.26"
    }
  }, [_vm._v("26")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Aguilar v. Felton, 473 U.S. 402 (1985); Lemon v. Kurtzman, 403 U.S. 602 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft13.27",
      "id": "fn.13.27"
    }
  }, [_vm._v("27")]), _vm._v(". This is a modest elaboration of the definition I offered in 1986:")]), _vm._v(" "), _c('p', {
    staticClass: "Quote1Sb"
  }, [_vm._v("I do not mean neutrality in the sense of a ban on religious classifications. Instead, I mean neutrality in the sense of government conduct that insofar as possible neither encourages nor discourages religious belief or practice. This requires identification of a base line from which to measure encouragement and discouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes-para1"
  }, [_vm._v("Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 3 (text at "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.5.10"
    }
  }, [_vm._v("note 10")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft14.28",
      "id": "fn.14.28"
    }
  }, [_vm._v("28")]), _vm._v(". "), _c('em', [_vm._v("Cf.")]), _vm._v(" Smith, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 316 n.192 (listing commentators who argue that neutrality, voluntarism, and separation are not consistent values).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft14.29",
      "id": "fn.14.29"
    }
  }, [_vm._v("29")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Torcaso v. Watkins, 367 U.S. 488, 496 (1961) (requiring atheist to affirm belief in God violates his “freedom of belief and religion”); "), _c('em', [_vm._v("cf.")]), _vm._v(" EEOC v. Townley Eng. & Mfg. Co., 859 F.2d 610, 613 (9th Cir. 1988) (requiring atheist employee to attend religious services at work discriminates against him on basis of religion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft14.30",
      "id": "fn.14.30"
    }
  }, [_vm._v("30")]), _vm._v(". Welsh v. United States, 398 U.S. 333, 344 (1970).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft16.31",
      "id": "fn.16.31"
    }
  }, [_vm._v("31")]), _vm._v(". Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 10–11 (text at "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.47"
    }
  }, [_vm._v("notes 47–56")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft16.32",
      "id": "fn.16.32"
    }
  }, [_vm._v("32")]), _vm._v(". "), _c('em', [_vm._v("See id.")]), _vm._v(" at 28–31 (text at notes 142–50). The Equal Access Act somewhat ineptly provides that schools should not sponsor student religious groups. 20 U.S.C. § 4071(c)(2) & (3) (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft16.33",
      "id": "fn.16.33"
    }
  }, [_vm._v("33")]), _vm._v(". "), _c('em', [_vm._v("E.g.")]), _vm._v(", Wallace v. Jaffree, 472 U.S. 38 (1985) (striking down statute authorizing moment of silence “for meditation or voluntary prayer” where legislative history showed intent to return prayer to public schools); School Dist. of Abington Township v. Schempp, 374 U.S. 203 (1963) (state cannot require daily Bible reading and recitation of Lord’s Prayer in public schools); Engel v. Vitale, 370 U.S. 421 (1962) (state may not compose or require recitation of official state prayer).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft17.34",
      "id": "fn.17.34"
    }
  }, [_vm._v("34")]), _vm._v(". Roemer v. Board of Public Works, 426 U.S. 736, 747 (1976).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft17.35",
      "id": "fn.17.35"
    }
  }, [_vm._v("35")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 746–47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft18.36",
      "id": "fn.18.36"
    }
  }, [_vm._v("36")]), _vm._v(". Ruti Teitel, "), _c('em', [_vm._v("The Unconstitutionality of Equal Access Policies and Legislation Allowing Organized Student-Initiated Religious Activities in the Public High Schools: A Proposal for a Unitary First Amendment Forum Analysis.")]), _vm._v(" 12 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASTINGS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". L.Q. 529, 562–65 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft18.37",
      "id": "fn.18.37"
    }
  }, [_vm._v("37")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 10 (text at "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.20.47"
    }
  }, [_vm._v("notes 47–48")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft18.38",
      "id": "fn.18.38"
    }
  }, [_vm._v("38")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 36, at 582.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft18.39",
      "id": "fn.18.39"
    }
  }, [_vm._v("39")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Bender v. Williamsport Area School Dist., 741 F.2d 538, 554–55 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 36, at 579–90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft19.40",
      "id": "fn.19.40"
    }
  }, [_vm._v("40")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.4.1"
    }
  }, [_vm._v("note 1")]), _vm._v(", at 16–17, 28, 47–51 (text at notes 79–92, 141, 225–42).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft19.41",
      "id": "fn.19.41"
    }
  }, [_vm._v("41")]), _vm._v(". "), _c('em', [_vm._v("See generally")]), _vm._v(" Robert Nagel, "), _c('em', [_vm._v("The Formulaic Constitution")]), _vm._v(", 84 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 165 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft19.42",
      "id": "fn.19.42"
    }
  }, [_vm._v("42")]), _vm._v(". Lemon v. Kurtzman, 403 U.S. 602, 612 (1971), "), _c('em', [_vm._v("as modified in")]), _vm._v(" Committee for Pub. Educ. & Religious Liberty v. Nyquist, 413 U.S. 756, 783–84 n.39 (1973).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft19.43",
      "id": "fn.19.43"
    }
  }, [_vm._v("43")]), _vm._v(". The antecedents of the test are traced in Douglas Laycock, "), _c('em', [_vm._v("Towards a General Theory of the Religion Clauses: The Case of Church Labor Relations and the Right to Church Autonomy")]), _vm._v(", 81 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1373, 1380–81 (1981) (text at notes 70–74).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft19.44",
      "id": "fn.19.44"
    }
  }, [_vm._v("44")]), _vm._v(". 473 U.S. 402 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft20.45",
      "id": "fn.20.45"
    }
  }, [_vm._v("45")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 411–12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft20.46",
      "id": "fn.20.46"
    }
  }, [_vm._v("46")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 412–14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft20.47",
      "id": "fn.20.47"
    }
  }, [_vm._v("47")]), _vm._v(". County of Allegheny v. American Civil Liberties Union Greater Pittsburgh Chapter, 492 U.S. 573, 657–58 (1989) (Kennedy, J., dissenting); W. H. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERLY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RISIS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIVERSITY")]), _vm._v(" 55–56 (1949); R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICHARD")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EUHAUS")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AKED")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UBLIC")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("QUARE")]), _vm._v(" (1984); James Hitchcock, "), _c('em', [_vm._v("Church, State and Moral Values: The Limits of American Pluralism")]), _vm._v(", 44 L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" & C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROBS")]), _vm._v(". 3 (Spring 1981); Andrew Woodbridge Hull, Note, "), _c('em', [_vm._v("A Moment of Silence: A Permissible Accommodation Protecting the Capacity to Form Religious Belief")]), _vm._v(", 61 I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ND")]), _vm._v(". L.J. 429, 431–33 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft20.48",
      "id": "fn.20.48"
    }
  }, [_vm._v("48")]), _vm._v(". The costs of implementing "), _c('em', [_vm._v("Aguilar")]), _vm._v(" are carefully assessed in T. V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITULLO")]), _vm._v("-M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARTIN")]), _vm._v(" & B. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OOPER")]), _vm._v(", S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EPARATION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILD")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSTITUTION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EDERAL")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ID")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOLS")]), _vm._v(" 41–66 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.49",
      "id": "fn.21.49"
    }
  }, [_vm._v("49")]), _vm._v(". Texas Monthly, Inc. v. Bullock, 489 U.S. 1, 10–17 (1989) (plurality opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.50",
      "id": "fn.21.50"
    }
  }, [_vm._v("50")]), _vm._v(". Aguilar v. Felton, 473 U.S. 402 (1985) (opinion of the Court by Brennan, J.).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.51",
      "id": "fn.21.51"
    }
  }, [_vm._v("51")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Goldman v. Weinberger, 475 U.S. 503, 520–24 (1986) (Brennan, J., dissenting); Wisconsin v. Yoder, 406 U.S. 205 (1972) (Brennan, J., joining opinion of the Court).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.52",
      "id": "fn.21.52"
    }
  }, [_vm._v("52")]), _vm._v(". "), _c('em', [_vm._v("Texas Monthly, Inc.")]), _vm._v(", 489 U.S. 1, 29–45 (Rehnquist, C.J., joining dissent of Scalia, J.); "), _c('em', [_vm._v("Aguilar")]), _vm._v(", 473 U.S. at 420–21 (Rehnquist, C.J., dissenting); "), _c('em', [_vm._v("Goldman")]), _vm._v(", 475 U.S. 503 (opinion of the Court); Thomas v. Review Bd., 450 U.S. 707, 720 (1981) (Rehnquist, C.J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.53",
      "id": "fn.21.53"
    }
  }, [_vm._v("53")]), _vm._v(". "), _c('em', [_vm._v("Texas Monthly, Inc.")]), _vm._v(", 489 U.S. 1, 10–17 (Stevens, J., joining plurality opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.54",
      "id": "fn.21.54"
    }
  }, [_vm._v("54")]), _vm._v(". "), _c('em', [_vm._v("Aguilar")]), _vm._v(", 473 U.S. 402 (Stevens, J., joining opinion of the Court).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.55",
      "id": "fn.21.55"
    }
  }, [_vm._v("55")]), _vm._v(". Goldman v. Weinberger, 475 U.S. 503, 510–13 (1986) (Stevens, J., concurring); United States v. Lee, 455 U.S. 252, 261–64 (1982) (Stevens, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft21.56",
      "id": "fn.21.56"
    }
  }, [_vm._v("56")]), _vm._v(". Employment Div. v. Smith, 494 U.S. 872 (1990); Jimmy Swaggart Ministries v. Board of Equalization, 493 U.S. 378 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.57",
      "id": "fn.22.57"
    }
  }, [_vm._v("57")]), _vm._v(". "), _c('em', [_vm._v("Swaggart")]), _vm._v(", 493 U.S. at 391–92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.58",
      "id": "fn.22.58"
    }
  }, [_vm._v("58")]), _vm._v(". 494 U.S. 872.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.59",
      "id": "fn.22.59"
    }
  }, [_vm._v("59")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 877 (quoting U.S. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". amend. I).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.60",
      "id": "fn.22.60"
    }
  }, [_vm._v("60")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 884.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.61",
      "id": "fn.22.61"
    }
  }, [_vm._v("61")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 878.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.62",
      "id": "fn.22.62"
    }
  }, [_vm._v("62")]), _vm._v(". Jimmy Swaggart Ministries v. Board of Equalization, 493 U.S. 378, 391, 394 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft22.63",
      "id": "fn.22.63"
    }
  }, [_vm._v("63")]), _vm._v(". "), _c('em', [_vm._v("Id.")]), _vm._v(" at 394.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft23.64",
      "id": "fn.23.64"
    }
  }, [_vm._v("64")]), _vm._v(". "), _c('em', [_vm._v("Smith")]), _vm._v(", 494 U.S. at 890.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft24.65",
      "id": "fn.24.65"
    }
  }, [_vm._v("65")]), _vm._v(". For news stories, see James Barron, "), _c('em', [_vm._v("Georgetown’s President Named Head of Public Library")]), _vm._v(", New York Times, Feb. 24, 1989, at B1, col. 2; Dena Kleiman, "), _c('em', [_vm._v("Jesuits See Library Post as Part of Their Mission")]), _vm._v(", New York Times, Feb. 25, 1989, at A33, col. 1; Peter Steinfels, "), _c('em', [_vm._v("Priest Picked for Library Post Responds to Critics")]), _vm._v(", New York Times, Apr. 2, 1989, at A29, col. 1. For editorials, one on each side, see "), _c('em', [_vm._v("The Librarian Priest")]), _vm._v(", New York Times, Mar. 21, 1989, at A24, col. 1 (opposed); "), _c('em', [_vm._v("Father Healy as Public Man")]), _vm._v(", New York Times, Apr. 9, 1989, at A26, col. 1 (supporting). For letters to the editor, see New York Times, Mar. 1, 1989, at A24, col. 3 (Gay Talese, opposed); New York Times, Mar. 16, 1989, at A30, col. 4 (Garry Wills, supporting); New York Times, Mar. 31, 1989, at A34, col. 3 (Joseph Heller, opposed: Albert H. Bowker & Joseph S. Murphy, supporting; Andrew Humm, Eleanor Cooper, and Tom Smith, opposed); New York Times, Apr. 13, 1989, at A26, col. 3 (Sen. Daniel Patrick Moynihan, supporting; Paul Halsall, supporting); New York Times, Apr. 21, 1989, at A30, col. 3 (Andrew M. Greeley, supporting); New York Times, May 8, 1989, at A18, col. 3 (Peter G. Finn, supporting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft25.66",
      "id": "fn.25.66"
    }
  }, [_vm._v("66")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", County of Allegheny v. American Civil Liberties Union Greater Pittsburgh Chapter, 492 U.S. 573, 668–77 (1989) (Kennedy, J., dissenting); Wallace v. Jaffree, 472 U.S. 38, 114 (1985) (Rehnquist, J., dissenting); Edwin Meese, "), _c('em', [_vm._v("The Supreme Court of the United States: Bulwark of a Limited Constitution")]), _vm._v(", 27 S. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 455, 464 (1986) (argument that Religion Clauses require neutrality between religion and nonreligion “would have struck the founding generation as bizarre”); John Whitehead & John Conlan, "), _c('em', [_vm._v("The Establishment of the Religion of Secular Humanism and Its First Amendment Implications")]), _vm._v(", 10 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 21–25 (1978) (Supreme Court rulings have replaced theism with secular humanism as an established faith).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft25.67",
      "id": "fn.25.67"
    }
  }, [_vm._v("67")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERBERT")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C")]), _vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOSKY")]), _vm._v(" & A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIDA")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RILL")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMENSIONS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLERANCE")]), _vm._v(": W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAT")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICANS")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HINK")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BOUT")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVIL")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTIES")]), _vm._v(" 133 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft25.68",
      "id": "fn.25.68"
    }
  }, [_vm._v("68")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Lynch v. Donnelly, 465 U.S. 668 (1984) (upholding municipal creche); Marsh v. Chambers, 463 U.S. 783 (1983) (upholding legislative chaplain who opens daily sessions with prayer).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft25.69",
      "id": "fn.25.69"
    }
  }, [_vm._v("69")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Widmar v. Vincent, 454 U.S. 263 (1981); Heffron v. International Soc’y for Krishna Consciousness, Inc., 452 U.S. 640 (1981); Poulos v. New Hampshire, 345 U.S. 395 (1953); West Virginia State Bd. of Educ. v. Barnette, 319 U.S. 624 (1943); Largent v. Texas, 318 U.S. 418 (1943); Cantwell v. Connecticut, 310 U.S. 296 (1940); Lovell v. City of Griffin, 303 U.S. 444 (1938).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft25.70",
      "id": "fn.25.70"
    }
  }, [_vm._v("70")]), _vm._v(". "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Buckley v. Valeo, 424 U.S. 1 (1976); L.A. Powe, "), _c('em', [_vm._v("Mass Speech")]), _vm._v(", 1982 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 243.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft26.71",
      "id": "fn.26.71"
    }
  }, [_vm._v("71")]), _vm._v(". 26 U.S.C. § 501(c)(3) (1982). For criticism of the use of tax exemptions to restrict religious speech, see Wilfred Caron & Deidre Dessingue, "), _c('em', [_vm._v("IRC § 501(c)(3): Practical and Constitutional Implications of “Political” Activity Restrictions")]), _vm._v(", 2 J.L. & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v(". 169 (1985); Edward Gaffney, "), _c('em', [_vm._v("On Not Rendering to Caesar: The Unconstitutionality of Tax Regulation of Activities of Religious Organizations Relating to Politics")]), _vm._v(", 40 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1 (1990) (forthcoming).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft26.72",
      "id": "fn.26.72"
    }
  }, [_vm._v("72")]), _vm._v(". Jimmy Swaggart Ministries v. Board of Equalization, 493 U.S. 378 (1990), discussed in text "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.21.56"
    }
  }, [_vm._v("notes 56–63")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft26.73",
      "id": "fn.26.73"
    }
  }, [_vm._v("73")]), _vm._v(". George v. International Soc’y for Krishna Consciousness, No. D007153 (Cal. App. 4th Dist. 1989), "), _c('em', [_vm._v("vacated")]), _vm._v(", 499 U.S. 914 (1991).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft26.74",
      "id": "fn.26.74"
    }
  }, [_vm._v("74")]), _vm._v(". "), _c('em', [_vm._v("Compare")]), _vm._v(" Frazee v. Illinois Dept. of Employment Sec., 489 U.S. 829 (1989) (employee who loses his job for religious reasons is entitled to unemployment compensation); Hobbie v. Unemployment Appeals Comm’n, 480 U.S. 136 (1987) (same); Thomas v. Review Bd., 450 U.S. 707 (1981) (same); Wisconsin v. Yoder, 406 U.S. 205 (1972) (Amish parents who conscientiously object to public high school exempted from compulsory education laws); Sherbert v. Verner, 374 U.S. 398 (1963) (another unemployment compensation case) "), _c('em', [_vm._v("with")]), _vm._v(" Goldman v. Weinberger, 475 U.S. 503 (1986) (military can discipline officer for wearing "), _c('em', [_vm._v("yarmulke")]), _vm._v(" with uniform); Bob Jones Univ. v. United States, 461 U.S. 574, 602–04 (1983) (pervasively religious school that conscientiously forbids interracial dating by students has no constitutional right to retain its charitable tax exemption); United States v. Lee, 455 U.S. 252 (1982) (conscientious objectors to social security have no constitutional right to refuse to pay social security taxes); Gillette v. United States, 401 U.S. 437 (1971) (conscientious objectors to unjust wars have no constitutional right to exemption from serving in such wars).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.75",
      "id": "fn.27.75"
    }
  }, [_vm._v("75")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Brief of the United States as Amicus Curiae Supporting Appellees at 7–10, Hobbie v. Florida Unemployment Comm’n, 480 U.S. 136 (1987) (No. 85–993) (arguing that government may "), _c('em', [_vm._v("restrict or penalize")]), _vm._v(" free exercise of religion as long as it does not "), _c('em', [_vm._v("prohibit")]), _vm._v(" free exercise of religion); Brief for the Appellants at 27–30, Bowen v. Roy, 476 U.S. 693 (1986) (No. 84–780) (arguing that government’s interest in denying constitutional exemption to conscientious objector must be measured by the cost of repealing the challenged law entirely, and not by the cost of exempting conscientious objectors); Brief for the Respondents, Goldman v. Weinberger, 475 U.S. 503 (1986) (No. 84–1097) (arguing against right to wear "), _c('em', [_vm._v("yarmulke")]), _vm._v(" with military uniform); Brief of the United States as Amicus Curiae at 5–15, Jensen v. Quaring, 472 U.S. 478 (1985) (No. 83–1944) (arguing that Constitution does not require exemption from photograph required for driver’s license); Brief for the United States at 15–18, United States v. Lee, 455 U.S. 252 (1982) (No. 80–767) (arguing that Constitution does not protect against indirect burdens on exercise of religion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.76",
      "id": "fn.27.76"
    }
  }, [_vm._v("76")]), _vm._v(". Employment Div. v. Smith, 494 U.S. 872 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.77",
      "id": "fn.27.77"
    }
  }, [_vm._v("77")]), _vm._v(". Ellis West, "), _c('em', [_vm._v("The Case Against a Right to Religion-Based Exemptions")]), _vm._v(", 4 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTRE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AME")]), _vm._v(" J.L. E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THICS")]), _vm._v(", & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UB")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OL")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" 591 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.78",
      "id": "fn.27.78"
    }
  }, [_vm._v("78")]), _vm._v(". William Marshall, "), _c('em', [_vm._v("The Case Against the Constitutionally Compelled Free Exercise Exemption")]), _vm._v(", 40 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASE")]), _vm._v(" W. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ES")]), _vm._v(". 357 (1989–90).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.79",
      "id": "fn.27.79"
    }
  }, [_vm._v("79")]), _vm._v(". "), _c('em', [_vm._v("But see")]), _vm._v(" Tushnet, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.11.23"
    }
  }, [_vm._v("note 23")]), _vm._v(", at 384, 402.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.80",
      "id": "fn.27.80"
    }
  }, [_vm._v("80")]), _vm._v(". "), _c('em', [_vm._v("Smith")]), _vm._v(", 494 U.S. at 877 (using example of “sacramental use of bread and wine”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft27.81",
      "id": "fn.27.81"
    }
  }, [_vm._v("81")]), _vm._v(". Oral exchange at Notre Dame conference on religious liberty, South Bend, Indiana, March 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.82",
      "id": "fn.28.82"
    }
  }, [_vm._v("82")]), _vm._v(". "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.83",
      "id": "fn.28.83"
    }
  }, [_vm._v("83")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Employment Div. v. Smith, 494 U.S. 872 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.84",
      "id": "fn.28.84"
    }
  }, [_vm._v("84")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Davis v. Beason, 133 U.S. 333 (1890).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.85",
      "id": "fn.28.85"
    }
  }, [_vm._v("85")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Reynolds v. United States, 98 U.S. 145 (1878).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.86",
      "id": "fn.28.86"
    }
  }, [_vm._v("86")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Late Corp. of the Church of Jesus Christ of Latter Day Saints v. United States, 136 U.S. 1 (1890).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.87",
      "id": "fn.28.87"
    }
  }, [_vm._v("87")]), _vm._v(". "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.88",
      "id": "fn.28.88"
    }
  }, [_vm._v("88")]), _vm._v(". See J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OONAN")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIEVER")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWERS")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAT")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RE")]), _vm._v(" 207 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft28.89",
      "id": "fn.28.89"
    }
  }, [_vm._v("89")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" George v. International Soc’y for Krishna Consciousness, No. D007153 (Cal. App. 4th Dist. 1989) ($32.7 million verdict reduced to $3 million), "), _c('em', [_vm._v("vacated")]), _vm._v(", 499 U.S. 914 (1991); Wollersheim v. Church of Scientology, 260 Cal. Rptr. 331 (Cal. App. 1989) ($30 million verdict remitted to $2.5 million), "), _c('em', [_vm._v("vacated")]), _vm._v(", 499 U.S. 914 (1991); Church Universal & Triumphant, Inc. v. Witt, No. B021187 (Cal. App. 2d Dist. 1989) ($1.5 million); O’Neil v. Schuckardt, 733 P.2d 693 (Idaho 1986) ($1 million); Christofferson v. Church of Scientology, 5 Religious Freedom Rptr. 126 (Or. Cir. Ct. Multnomah County 1985) ($39 million). For earlier proceedings in "), _c('em', [_vm._v("Christofferson")]), _vm._v(", see 644 P.2d 577 (Or. App. 1982). The California courts appear not to believe that judicial destruction of a minority faith even requires a published opinion.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft29.90",
      "id": "fn.29.90"
    }
  }, [_vm._v("90")]), _vm._v(". Guinn v. Church of Christ, 775 P.2d 766 (Okla. 1989) ($390,000 against local congregation).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft29.91",
      "id": "fn.29.91"
    }
  }, [_vm._v("91")]), _vm._v(". Goldman v. Weinberger, 475 U.S. 503 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft29.92",
      "id": "fn.29.92"
    }
  }, [_vm._v("92")]), _vm._v(". 10 U.S.C. § 774 (1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft29.93",
      "id": "fn.29.93"
    }
  }, [_vm._v("93")]), _vm._v(". Quaring v. Peterson, 728 F.2d 1121 (8th Cir. 1984), "), _c('em', [_vm._v("aff’d by equally divided Court, sub nom.")]), _vm._v(" Jensen v. Quaring, 472 U.S. 478 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft30.94",
      "id": "fn.30.94"
    }
  }, [_vm._v("94")]), _vm._v(". I elaborate on the second-chance rationale for judicial review in Douglas Laycock, "), _c('em', [_vm._v("Notes on the Role of Judicial Review, the Expansion of Federal Power, and the Structure of Constitutional Rights")]), _vm._v(" (Book Review), 99 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 1711, 1727–30 (1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft30.95",
      "id": "fn.30.95"
    }
  }, [_vm._v("95")]), _vm._v(". See B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARTLETT")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMILIAR")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UOTATIONS")]), _vm._v(" 802a (14th ed. 1968) (“The law, in its majestic equality, forbids the rich as well as the poor to sleep under bridges, to beg in the streets, and to steal bread”) (quoting A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NATOLE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANCE")]), _vm._v(", L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YS")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUGE")]), _vm._v(" (1894)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft31.96",
      "id": "fn.31.96"
    }
  }, [_vm._v("96")]), _vm._v(". "), _c('em', [_vm._v("See")]), _vm._v(" Mayer Freed & Daniel Polsby, "), _c('em', [_vm._v("Race, Religion, and Public Policy:")]), _vm._v(" Bob Jones University v. United States, 1983 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 20–30; Marshall, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.78"
    }
  }, [_vm._v("note 78")]), _vm._v("; West, "), _c('em', [_vm._v("supra")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#fn.27.77"
    }
  }, [_vm._v("note 77")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft31.97",
      "id": "fn.31.97"
    }
  }, [_vm._v("97")]), _vm._v(". "), _c('em', [_vm._v("See generally")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EON")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTINGER")]), _vm._v(", A T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEORY")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OGNITIVE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISSONANCE")]), _vm._v(" 1–31, 84–122 (1957).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft32.98",
      "id": "fn.32.98"
    }
  }, [_vm._v("98")]), _vm._v(". 50 U.S.C. App. § 456(j) (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft32.99",
      "id": "fn.32.99"
    }
  }, [_vm._v("99")]), _vm._v(". 29 U.S.C. § 169 (Supp. V. 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ft32.100",
      "id": "fn.32.100"
    }
  }, [_vm._v("100")]), _vm._v(". M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULFORD")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBLEY")]), _vm._v(" & P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILIP")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACOB")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSCRIPTION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSCIENCE")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSCIENTIOUS")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BJECTOR")]), _vm._v(", 1940–1947, at 84 (1952).")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes-para"
  }, [_vm._v("This article is adapted from the Sixth Annual Lecture of the Center for Church/State Studies, delivered in Chicago, Illinois, on April 6, 1989. Much of the argument speaks as of that date. In the interim, the Supreme Court has announced sweeping changes in the relevant law. Initial reaction to those changes is largely confined to inserts.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_vm._v("I am grateful to the DePaul University Law School and the Center for Church/State Studies for their invitation, support, and helpful reactions to this lecture; to Jay Westbrook and Sanford Levinson for helpful comments on an earlier written draft; and to the University Research Institute at the University of Texas for a research leave that made it possible for me to accept DePaul’s invitation.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_vm._v("I should disclose that I wrote and filed amicus briefs in the Supreme Court in the following cases cited or discussed in this Article: George v. International Soc’y for Krishna Consciousness, 499 U.S. 914 (1991); Board of Educ. v. Mergens, 496 U.S. 226 (1990); Jimmy Swaggart Ministries v. Board of Equalization, 493 U.S. 378 (1990), and that I was of counsel on the petition for rehearing in Employment Div. v. Smith, 494 U.S. 872 (1990).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71d3637a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Chapter02.vue
// module id = 84
// module chunks = 0